export const HOME_PATH = '/';
export const VERIFY_PATH = '/verify';
export const SIGN_IN_PATH = '/signin';
export const SIGN_UP_PATH = '/signup';
export const FORGOT_PASSWORD_PATH = '/recover';
export const RECOVER_PASSWORD_PATH = '/recover-confirm';
export const PRIVACY_PATH = '/privacy';
export const CIRCLE_OF_TRUST_PATH = '/settings/friends';
export const DASHBOARD_PATH = '/dashboard';
export const TRENDING_PATH = '/trending';
export const IRIS_PATH = '/iris';
export const FRIENDS_FAMILY_PATH = '/friends-family';
export const PLAN_SELECTION_PATH = '/plan-selection';
export const BILLING_PATH = '/billing';
export const BLOG_PATH = '/blog';

/** Dashboard query param that expands one watched-over person's alerts. */
export const WATCHING_ALERTS_QUERY_PARAM = 'alerts';
/** Anchor id of the dashboard's "People You're Watching Over" section. */
export const WATCHING_OVER_SECTION_ID = 'watching-over';
